export default class ScrollGradient {
    constructor(el) {
        this.DOM = { el: el };
        this.startSelector = this.DOM.el.dataset.scrollStartSelector || '[data-scroll-start]';
        this.endSelector = this.DOM.el.dataset.scrollEndSelector || '[data-scroll-end]';
        this.linkSelector = this.DOM.el.dataset.scrollLinkSelector || 'a';

        this.DOM.scrollStart = this.DOM.el.querySelector(this.startSelector);
        this.DOM.scrollEnd = this.DOM.el.querySelector(this.endSelector);
        this.links = Array.from(this.DOM.el.querySelectorAll(this.linkSelector));

        this.lastScrollLeft = this.DOM.el.scrollLeft;
        this.lastInteractionTime = 0;
        this.scrollSuppressDuration = 500; // ms

        this.initEvents();
        this.observeGradientEdges();
        this.observeActiveLink();
        this.monitorScrollActivity();
    }

    initEvents() {
        const markInteraction = () => {
            this.lastInteractionTime = performance.now();
        };

        // Interacties die scrollintentie aanduiden
        this.DOM.el.addEventListener('wheel', markInteraction, { passive: true });
        this.DOM.el.addEventListener('touchstart', markInteraction, { passive: true });
        this.DOM.el.addEventListener('touchmove', markInteraction, { passive: true });
        this.DOM.el.addEventListener('scroll', markInteraction, { passive: true });

        // Klik op link forceert scroll (tenzij gebruiker handmatig scrollt)
        this.DOM.el.addEventListener('click', (e) => {
            const link = e.target.closest('a');
            if (!link || !this.DOM.el.contains(link)) return;

            setTimeout(() => {
                if (!this.isUserStillScrolling()) {
                    this.scrollLinkIntoView(link);
                }
            }, 50);
        });
    }

    observeGradientEdges() {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                let className = '';

                if (entry.target === this.DOM.scrollStart) {
                    className = 'scroll-start';
                } else if (entry.target === this.DOM.scrollEnd) {
                    className = 'scroll-end';
                }

                this.DOM.el.classList[entry.isIntersecting ? 'add' : 'remove'](className);
            });
        }, {
            root: this.DOM.el,
            rootMargin: '1px',
        });

        observer.observe(this.DOM.scrollStart);
        observer.observe(this.DOM.scrollEnd);
    }

    observeActiveLink() {
        const observer = new MutationObserver(() => {
            const active = this.links.find(link => link.classList.contains('active'));
            if (active && !this.isUserStillScrolling()) {
                this.scrollLinkIntoView(active);
            }
        });

        observer.observe(this.DOM.el, {
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });
    }

    scrollLinkIntoView(link) {
        const offsetLeft = link.offsetLeft - this.DOM.el.scrollLeft;
        const scrollOffset = offsetLeft - (this.DOM.el.clientWidth / 2 - link.offsetWidth / 2);

        this.DOM.el.scrollTo({
            left: this.DOM.el.scrollLeft + scrollOffset,
            behavior: 'smooth'
        });
    }

    isUserStillScrolling() {
        return (performance.now() - this.lastInteractionTime) < this.scrollSuppressDuration;
    }

    monitorScrollActivity() {
        const checkScroll = () => {
            const currentScroll = this.DOM.el.scrollLeft;
            if (currentScroll !== this.lastScrollLeft) {
                this.lastInteractionTime = performance.now();
                this.lastScrollLeft = currentScroll;
            }
            requestAnimationFrame(checkScroll);
        };
        requestAnimationFrame(checkScroll);
    }
}

document.querySelectorAll('[data-scroll-gradient]').forEach((element) => {
    new ScrollGradient(element);
});
